<template>
  <div class="lee-img-contrast" ref="contrast" :class="[thedirection]" :style="{'color':color}">
    <div class="tool" :style="thedirection==='horizontal'?'left:'+posx+'%':'top:'+posx+'%'" @mousedown.prevent="mousedown"
         @touchstart.prevent="touchstart">
      <div class="arrow"><span class="le" @click="left"></span><span class="ri" @click="right"></span></div>
    </div>
    <div class="front-img" :style="thedirection==='horizontal'?'width:'+posx+'%':'height:'+posx+'%'">
      <div class="mark"></div>
      <img :src="frontImg">
    </div>
    <div class="back-img">
      <img :src="backImg">
    </div>
  </div>
</template>
<script>
export default {
    name: 'LeeImgContrast',
    data() {
        return {
            thedirection:'',
            fullw: 0,
            posx: 0,
            down: false,
            oldx: 0,
            savex: 0
        }
    },
    watch: {
        direction: {
            immediate: true,
            handler(value) {
                let types=['horizontal','vertical']
                let fi=types.filter(function(el) {
                    return el.indexOf(value)>-1;
                })
                if(fi.length<1){
                    this.thedirection="horizontal"
                }else{
                    this.thedirection=value
                }
            }
        },
    },
    methods: {
        chuli() {
            if (this.oldx === 0) {//并且没有滑动过
                this.posx = 50
                this.savex = this.posx
            }
            document.addEventListener('mousedown', (e) => {
                e.preventDefault()
            })
            document.addEventListener('mousemove', (e) => {
                let mm;
                if (this.thedirection === 'horizontal') {
                    mm = Math.round((e.pageX - this.oldx) / this.fullw * 100)
                } else {
                    mm = Math.round((e.pageY - this.oldx) / this.fullw * 100)
                }

                if (this.down) {
                    this.posx = this.savex + mm
                    if (this.posx >= 100) {
                        this.posx = 100
                    }
                    if (this.posx <= 0) {
                        this.posx = 0
                    }
                }
            })
            document.addEventListener('mouseup', (e) => {
                this.down = false
                this.savex = this.posx
            })
            document.addEventListener('touchmove', (e) => {
                let mm;
                if (this.thedirection === 'horizontal') {
                    mm = Math.round((e.targetTouches[0].pageX - this.oldx) / this.fullw * 100)
                } else {
                    mm = Math.round((e.targetTouches[0].pageY - this.oldx) / this.fullw * 100)
                }
                if (this.down) {
                    this.posx = this.savex + mm
                    if (this.posx >= 100) {
                        this.posx = 100
                    }
                    if (this.posx <= 0) {
                        this.posx = 0
                    }
                }

            })
            document.addEventListener('touchend', (e) => {
                this.down = false
                this.savex = this.posx
            })
        },
        mousedown() {
            this.down = true
            if (this.thedirection === 'horizontal') {
                this.oldx = event.pageX
            } else {
                this.oldx = event.pageY
            }
        },
        touchstart() {
            this.down = true
            if (this.thedirection === 'horizontal') {
                this.oldx = event.targetTouches[0].pageX
            } else {
                this.oldx = event.targetTouches[0].pageY
            }

        },
        left() {
            let lst = setInterval(() => {
                this.posx--
                if (this.posx <= 0) {
                    this.posx = 0
                    this.savex=0
                    clearInterval(lst)
                }
            }, 10)
        },
        right() {
            let rst = setInterval(() => {
                this.posx++
                if (this.posx >= 100) {
                    this.posx = 100
                    this.savex=100
                    clearInterval(rst)
                }
            }, 10)
        }
    },
    mounted() {
        let sel = this.$refs.contrast
        let ww = sel.offsetWidth
        let img = new Image()
        img.src = sel.querySelector('img').src
        img.onload = () => {
            if (this.thedirection === 'horizontal') {
                this.fullw = ww
            } else {
                this.fullw = img.height / img.width * ww
            }
            this.chuli()
        }
        window.addEventListener('resize', (e) => {
            ww = sel.offsetWidth
            if (this.thedirection === 'horizontal') {
                this.fullw = ww
            } else {
                this.fullw = img.height / img.width * ww
            }
            this.chuli()
        })


    },
    props: {

        frontImg: {
            type: String,
            default: '/imgcontrast/1.jpg'
        },
        backImg: {
            type: String,
            default: '/imgcontrast/2.jpg'
        },
        direction: {
            type: String,
            default: 'horizontal'
        },
        color: {
            type: String,
            default: '#3eaf7c'
        }
    }
};
</script>
<style>
.lee-img-contrast {
  width: 100%;
  box-shadow: 0 0 4px rgba(0, 0, 0, .2);
  position: relative;
}

.lee-img-contrast .tool {
  position: absolute;
  z-index: 4;
  background: currentColor;
  width: 2px;
  height: 100%;
  top: 0px;
  cursor: w-resize;
}

.lee-img-contrast.vertical .tool {
  height: 2px;
  width: 100%;
  left: 0px;
  cursor: s-resize;
}

.lee-img-contrast .tool .arrow {
  border-radius: 100%;
  background: #fff;
  width: 34px;
  height: 34px;
  position: absolute;
  left: 50%;
  margin-left: -17px;
  margin-top: -17px;
  border: solid 2px currentColor;
  top: 50%;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lee-img-contrast.vertical .tool .arrow {
  flex-direction: column;
}

.lee-img-contrast .tool .arrow span {
  border-width: 6px;
  border-style: solid;
}

.lee-img-contrast .tool .arrow .le {
  border-color: transparent currentColor transparent transparent;
}

.lee-img-contrast .tool .arrow .ri {
  border-color: transparent transparent transparent currentColor;
}

.lee-img-contrast.vertical .tool .arrow .le {
  border-color: transparent transparent currentColor transparent;
}

.lee-img-contrast.vertical .tool .arrow .ri {
  border-color: currentColor transparent transparent transparent;
}

.lee-img-contrast .front-img {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 3;
  left: 0;
  top: 0;
  overflow: hidden;
}

.lee-img-contrast .front-img .mark {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, .3);
}


.lee-img-contrast .back-img {
  display: flex;
}

.lee-img-contrast .front-img img {
  height: 100%;
  max-width: inherit !important;
}

.lee-img-contrast.vertical .front-img img {
  width: 100%;
  height: auto;
}

.lee-img-contrast .back-img img {
  width: 100%;
  max-width: inherit !important;
}
</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeImgContrast.vue